import React from 'react';
import App from './src/App';
import './src/styles/style.sass';

export const wrapRootElement = ({ element }) => <><App element={element} /><iframe id="silentLogout" hidden></iframe> </>;
